
import React from 'react';
import Navidad from "./navidad";
import ParticleBackground from './Config/ParticleBackground';

function App() {
  return (

    <div>

    <ParticleBackground />
    <Navidad/>
    </div>
    
    
  );
}

export default App;
